import { DataOverrideService } from '@/services/pa/dataoverride.service';

import { PA_CREATE_DATAOVERRIDE, PA_CREATE_DATAOVERRIDE_CLEAR_MESSAGE, PA_SEARCH_DATAOVERRIDE } from './actions.type';
import { SET_PA_CREATE_DATAOVERRIDE_COMPLETE, SET_PA_CREATE_DATAOVERRIDE_BUSY, SET_PA_SEARCH_DATAOVERRIDE_COMPLETE } from './mutations.type';
import { ERROR_HANDLE_ERROR, ERROR_CLEAR_ERROR } from '../error/actions.type';

const initialState = {
    isBusy: false,
    message: '',
    searchResults: ''
};

export const state = Object.assign({}, initialState);

export const actions = {
    [PA_CREATE_DATAOVERRIDE](context, body) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.dispatch(PA_CREATE_DATAOVERRIDE_CLEAR_MESSAGE);

        context.commit(SET_PA_CREATE_DATAOVERRIDE_BUSY, true);
        return DataOverrideService.query(body)
            .then(({ data }) => {
                context.commit(SET_PA_CREATE_DATAOVERRIDE_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_PA_CREATE_DATAOVERRIDE_COMPLETE, data);
                    context.dispatch(PA_SEARCH_DATAOVERRIDE);
                }
                return data;
            },
            (err) => {
                context.dispatch(ERROR_HANDLE_ERROR, err);
                context.commit(SET_PA_CREATE_DATAOVERRIDE_BUSY, false);
            });
    },
    [PA_CREATE_DATAOVERRIDE_CLEAR_MESSAGE]: function (context) {
        context.commit(SET_PA_CREATE_DATAOVERRIDE_COMPLETE, null);
    },
    [PA_SEARCH_DATAOVERRIDE](context) {
        context.commit(SET_PA_CREATE_DATAOVERRIDE_BUSY, true);
                return DataOverrideService.get()
        .then(({ data }) => {
            context.commit(SET_PA_CREATE_DATAOVERRIDE_BUSY, false);
            if (data.errorMessage) {
                context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
            } else {
                context.commit(SET_PA_SEARCH_DATAOVERRIDE_COMPLETE, data);
            }
            return data;
        },
        (err) => {
            context.dispatch(ERROR_HANDLE_ERROR, err);
            context.commit(SET_PA_CREATE_DATAOVERRIDE_BUSY, false);
        });
    }
};

const getters = {};

export const mutations = {
    [SET_PA_CREATE_DATAOVERRIDE_COMPLETE](state, results) {
        state.message = results;
    },
    [SET_PA_CREATE_DATAOVERRIDE_BUSY](state, isBusy) {
        state.isBusy = isBusy;
    },
    [SET_PA_SEARCH_DATAOVERRIDE_COMPLETE](state, results) {
        state.searchResults = results;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};



// WEBPACK FOOTER //
// ./src/store/dataoverride/dataoverride.module.js